import React, { Component } from "react";
import {
  AutoAwesome,
  AutoFixHigh,
  Close,
  Explore,
  History as HistoryIcon,
  Search,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Pagination,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";

const FEATURE_GENERATE = "GENERATE";
const FEATURE_POLISH = "POLISH";
const FEATURE_COMPASS = "COMPASS";

// TODO: ganti dengan data dari backend (belum ada endpoint riwayat AI) — data di bawah hanya untuk kebutuhan UI
const DUMMY_HISTORY = [
  {
    id: "h1",
    type: FEATURE_GENERATE,
    aiModel: "gpt-4o-mini",
    salesName: "Dewi Anggraini",
    customerNumber: "6281234567890",
    createdAt: "2026-07-30 09:12:00",
    result: {
      reply: [
        { text: "Selamat pagi Kak, mau saya bantu pilihkan bucket bunga untuk acara wisuda?" },
        { text: "Halo Kak, stok bucket wisuda hari ini masih banyak, mau saya kirimkan katalognya?" },
        { text: "Terima kasih sudah menunggu Kak, ini rekomendasi terlaris untuk wisuda." },
        { text: "Kak, boleh info tanggal acaranya supaya saya bantu siapkan pengiriman?" },
      ],
    },
  },
  {
    id: "h2",
    type: FEATURE_POLISH,
    aiModel: "gpt-4o",
    salesName: "Bagas Saputra",
    customerNumber: "6285711122233",
    createdAt: "2026-07-30 10:41:00",
    input: { message: "iya kak itu bs kirim besok pagi ya, jam 8an" },
    result: {
      reply: {
        polished: "Baik Kak, pesanan bisa kami kirimkan besok pagi sekitar pukul 08.00 ya.",
      },
    },
  },
  {
    id: "h3",
    type: FEATURE_COMPASS,
    aiModel: "gemini-1.5-flash",
    salesName: "Nadia Ramadhani",
    customerNumber: "6289933344455",
    createdAt: "2026-07-30 13:05:00",
    result: {
      reply: {
        condition: "Customer sudah 3 kali bertanya harga namun belum melakukan pemesanan, kemungkinan masih membandingkan dengan toko lain.",
        actions: ["Tawarkan promo bundling", "Tanyakan kendala harga", "Follow up dalam 1 hari"],
        suggestedMessage: "Halo Kak, untuk pemesanan hari ini ada promo gratis kartu ucapan lho, mau saya bantu proseskan sekarang?",
      },
    },
  },
  {
    id: "h4",
    type: FEATURE_GENERATE,
    aiModel: "claude-3-haiku",
    salesName: "Dewi Anggraini",
    customerNumber: "6281298765432",
    createdAt: "2026-07-29 16:20:00",
    result: {
      reply: [
        { text: "Halo Kak, apakah pesanan kemarin sudah diterima dengan baik?" },
        { text: "Selamat siang Kak, mau tanya apakah bunganya sudah sampai tujuan?" },
        { text: "Terima kasih Kak sudah order, jangan lupa foto testimoni ya kalau berkenan." },
        { text: "Halo Kak, ada yang bisa saya bantu untuk pesanan berikutnya?" },
      ],
    },
  },
  {
    id: "h5",
    type: FEATURE_POLISH,
    aiModel: "gpt-4o-mini",
    salesName: "Rizky Firmansyah",
    customerNumber: "6287788899900",
    createdAt: "2026-07-29 08:55:00",
    input: { message: "maaf kak salah kirim invoice, ini yang bener" },
    result: {
      reply: {
        polished: "Mohon maaf Kak sebelumnya ada kesalahan invoice, berikut kami lampirkan invoice yang sudah benar.",
      },
    },
  },
  {
    id: "h6",
    type: FEATURE_COMPASS,
    aiModel: "gpt-4o",
    salesName: "Bagas Saputra",
    customerNumber: "6281355566677",
    createdAt: "2026-07-28 19:30:00",
    result: {
      reply: {
        condition: "Customer sudah melakukan pembayaran DP namun belum melunasi sisa pembayaran H-1 sebelum pengiriman.",
        actions: ["Ingatkan pelunasan", "Kirim rincian sisa tagihan"],
        suggestedMessage: "Halo Kak, mengingatkan kembali untuk pelunasan pesanan sebelum dikirim besok ya, berikut rincian tagihannya.",
      },
    },
  },
];

const PAGE_SIZE = 4;

const FEATURE_META = {
  [FEATURE_GENERATE]: { label: "Generate", color: "#7c4dff", icon: <AutoAwesome sx={{ fontSize: 14 }} /> },
  [FEATURE_POLISH]: { label: "Polish", color: "#0288d1", icon: <AutoFixHigh sx={{ fontSize: 14 }} /> },
  [FEATURE_COMPASS]: { label: "Compass", color: "#2e7d32", icon: <Explore sx={{ fontSize: 14 }} /> },
};

class AiHistoryDialog extends Component {
  state = {
    searchTerm: "",
    typeFilter: "ALL",
    selectedItem: null,
    page: 1,
  };

  handleSearchChange = (event) => {
    this.setState({ searchTerm: event.target.value, page: 1 });
  };

  handleTypeFilterChange = (event, value) => {
    if (value === null) return;
    this.setState({ typeFilter: value, page: 1 });
  };

  handlePageChange = (event, page) => {
    this.setState({ page });
  };

  handleSelectItem = (item) => {
    this.setState({ selectedItem: item });
  };

  handleClose = () => {
    this.setState({ searchTerm: "", typeFilter: "ALL", selectedItem: null, page: 1 });
    this.props.onClose();
  };

  getPreviewText = (item) => {
    if (item.type === FEATURE_GENERATE) return item.result?.reply?.[0]?.text || "-";
    if (item.type === FEATURE_POLISH) return item.result?.reply?.polished || "-";
    if (item.type === FEATURE_COMPASS) return item.result?.reply?.condition || "-";
    return "-";
  };

  getFilteredItems = () => {
    const { searchTerm, typeFilter } = this.state;
    const keyword = searchTerm.trim().toLowerCase();

    return DUMMY_HISTORY.filter((item) => {
      const matchType = typeFilter === "ALL" || item.type === typeFilter;
      if (!matchType) return false;

      if (!keyword) return true;

      const haystack = [item.salesName, item.customerNumber, this.getPreviewText(item)]
        .join(" ")
        .toLowerCase();

      return haystack.includes(keyword);
    });
  };

  getPaginatedItems = (filteredItems) => {
    const start = (this.state.page - 1) * PAGE_SIZE;
    return filteredItems.slice(start, start + PAGE_SIZE);
  };

  ComponentDetail = () => {
    const { selectedItem } = this.state;

    if (!selectedItem) {
      return (
        <Box sx={{ color: "#8a8f9c", fontSize: 13, textAlign: "center", mt: 4 }}>
          Pilih salah satu riwayat di sebelah kiri untuk melihat detail lengkap
        </Box>
      );
    }

    const meta = FEATURE_META[selectedItem.type];

    return (
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", mb: "10px" }}>
          <Chip
            size="small"
            icon={meta.icon}
            label={meta.label}
            sx={{ backgroundColor: `${meta.color}22`, color: meta.color, fontWeight: 600 }}
          />
          <Typography variant="caption" sx={{ color: "#8a8f9c" }}>
            {selectedItem.createdAt}
          </Typography>
        </Box>

        <Typography variant="body2" sx={{ mb: "2px" }}>
          <strong>Sales:</strong> {selectedItem.salesName}
        </Typography>
        <Typography variant="body2" sx={{ mb: "10px" }}>
          <strong>Customer:</strong> {selectedItem.customerNumber}
        </Typography>

        <Divider sx={{ mb: "10px" }} />

        {selectedItem.type === FEATURE_GENERATE && (
          <List dense sx={{ p: 0 }}>
            {selectedItem.result?.reply?.map((suggestion, index) => (
              <ListItemButton key={index} disabled sx={{ borderRadius: "10px", opacity: 1, mb: "4px", backgroundColor: "#fff" }}>
                <ListItemAvatar>
                  <Avatar sx={{ width: 26, height: 26, fontSize: 12, bgcolor: meta.color }}>{index + 1}</Avatar>
                </ListItemAvatar>
                <ListItemText primary={suggestion.text} primaryTypographyProps={{ fontSize: 13 }} />
              </ListItemButton>
            ))}
          </List>
        )}

        {selectedItem.type === FEATURE_POLISH && (
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" sx={{ color: "#5a5f73", fontWeight: 600 }}>
                SEBELUM
              </Typography>
              <Box sx={{ backgroundColor: "#ffffff", borderRadius: "10px", p: "10px", fontSize: 13, color: "#8a8f9c" }}>
                {selectedItem.input?.message}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" sx={{ color: "#5a5f73", fontWeight: 600 }}>
                SESUDAH DIPOLES
              </Typography>
              <Box sx={{ backgroundColor: "#ffffff", borderRadius: "10px", p: "10px", fontSize: 13, color: "#323233" }}>
                {selectedItem.result?.reply?.polished}
              </Box>
            </Grid>
          </Grid>
        )}

        {selectedItem.type === FEATURE_COMPASS && (
          <Box>
            <Typography variant="caption" sx={{ color: "#5a5f73", fontWeight: 600 }}>
              KONDISI CUSTOMER
            </Typography>
            <Typography variant="body2" sx={{ color: "#323233", mb: "10px" }}>
              {selectedItem.result?.reply?.condition}
            </Typography>

            {selectedItem.result?.reply?.actions?.length > 0 && (
              <>
                <Typography variant="caption" sx={{ color: "#5a5f73", fontWeight: 600 }}>
                  SARAN ACTIONS
                </Typography>
                <Box sx={{ mt: "4px", mb: "10px", display: "flex", gap: "6px", flexWrap: "wrap" }}>
                  {selectedItem.result.reply.actions.map((action, index) => (
                    <Chip
                      key={index}
                      size="small"
                      label={action}
                      sx={{
                        backgroundColor: "#e8f5e9",
                        color: "#2e7d32",
                        height: "auto",
                        maxWidth: "100%",
                        "& .MuiChip-label": { display: "block", whiteSpace: "normal", wordBreak: "break-word", py: "4px" },
                      }}
                    />
                  ))}
                </Box>
              </>
            )}

            {selectedItem.result?.reply?.suggestedMessage && (
              <>
                <Typography variant="caption" sx={{ color: "#5a5f73", fontWeight: 600 }}>
                  SUGGESTED MESSAGE
                </Typography>
                <Box sx={{ backgroundColor: "#f4f6f8", borderRadius: "10px", p: "10px", fontSize: 13, color: "#323233" }}>
                  {selectedItem.result.reply.suggestedMessage}
                </Box>
              </>
            )}
          </Box>
        )}
      </Box>
    );
  };

  render() {
    const { open } = this.props;
    const { searchTerm, typeFilter, selectedItem, page } = this.state;
    const filteredItems = this.getFilteredItems();
    const paginatedItems = this.getPaginatedItems(filteredItems);
    const totalPages = Math.max(1, Math.ceil(filteredItems.length / PAGE_SIZE));

    return (
      <Dialog open={open} onClose={this.handleClose} fullWidth maxWidth="md" PaperProps={{ sx: { borderRadius: "16px" } }}>
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pb: "8px" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <HistoryIcon sx={{ color: "#5a5f73" }} />
            <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 600 }}>
              Riwayat AI Sales Agent
            </Typography>
          </Box>
          <IconButton size="small" onClick={this.handleClose}>
            <Close fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ p: "16px" }}>
          <Box sx={{ display: "flex", gap: "8px", mb: "14px", flexWrap: "wrap" }}>
            <TextField
              size="small"
              placeholder="Cari nama sales, nomor customer, atau isi pesan..."
              value={searchTerm}
              onChange={this.handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search fontSize="small" sx={{ color: "#8a8f9c" }} />
                  </InputAdornment>
                ),
              }}
              sx={{ flex: 1, minWidth: 220 }}
            />

            <ToggleButtonGroup
              size="small"
              exclusive
              value={typeFilter}
              onChange={this.handleTypeFilterChange}
              sx={{ "& .MuiToggleButton-root": { textTransform: "none", fontSize: 12, py: "4px", px: "10px" } }}
            >
              <ToggleButton value="ALL">Semua</ToggleButton>
              <ToggleButton value={FEATURE_GENERATE}>Generate</ToggleButton>
              <ToggleButton value={FEATURE_POLISH}>Polish</ToggleButton>
              <ToggleButton value={FEATURE_COMPASS}>Compass</ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} md={5}>
              <Box sx={{ maxHeight: "48vh", overflowY: "auto", border: "1px solid #eaeef2", borderRadius: "10px" }}>
                {filteredItems.length === 0 && (
                  <Box sx={{ p: "16px", textAlign: "center", color: "#8a8f9c", fontSize: 13 }}>
                    Tidak ada riwayat yang cocok dengan pencarian
                  </Box>
                )}

                {filteredItems.length > 0 && (
                  <List sx={{ p: 0 }}>
                    {paginatedItems.map((item) => {
                      const meta = FEATURE_META[item.type];
                      return (
                        <React.Fragment key={item.id}>
                          <ListItemButton
                            selected={selectedItem?.id === item.id}
                            onClick={() => this.handleSelectItem(item)}
                            sx={{ alignItems: "flex-start", py: "8px" }}
                          >
                            <ListItemText
                              primary={
                                <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mb: "2px" }}>
                                  <Chip
                                    size="small"
                                    label={meta.label}
                                    sx={{ height: 18, fontSize: 10, fontWeight: 600, backgroundColor: `${meta.color}22`, color: meta.color }}
                                  />
                                  <Typography variant="caption" sx={{ color: "#8a8f9c" }}>
                                    {item.createdAt}
                                  </Typography>
                                </Box>
                              }
                              secondary={
                                <>
                                  <Typography component="span" variant="body2" sx={{ display: "block", fontWeight: 600, color: "#323233" }}>
                                    {item.salesName} • {item.customerNumber}
                                  </Typography>
                                  <Typography
                                    component="span"
                                    variant="caption"
                                    sx={{
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      color: "#5a5f73",
                                    }}
                                  >
                                    {this.getPreviewText(item)}
                                  </Typography>
                                </>
                              }
                            />
                          </ListItemButton>
                          <Divider component="li" />
                        </React.Fragment>
                      );
                    })}
                  </List>
                )}
              </Box>

              {totalPages > 1 && (
                <Box sx={{ display: "flex", justifyContent: "center", mt: "10px" }}>
                  <Pagination
                    size="small"
                    count={totalPages}
                    page={page}
                    onChange={this.handlePageChange}
                    shape="rounded"
                  />
                </Box>
              )}
            </Grid>

            <Grid item xs={12} md={7}>
              <Box sx={{ backgroundColor: "#f7f9fb", borderRadius: "10px", p: "14px", minHeight: "55vh" }}>
                <this.ComponentDetail />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

export default AiHistoryDialog;
